import api from '../api';
var DayOffsApi = /** @class */ (function () {
    function DayOffsApi() {
    }
    DayOffsApi.getAll = function (startDate, endDate) {
        var request = {
            params: {
                startDate: startDate,
                endDate: endDate
            }
        };
        return api.get('api/dayoffs', request).then(function (i) { return i.data; });
    };
    return DayOffsApi;
}());
export default DayOffsApi;



//////////////////
// WEBPACK FOOTER
// ./src/services/DayOffsApi.ts
// module id = 790
// module chunks = 0